import type { ConfigTagsInputProps } from './ConfigTagsInput.types'
import type { TagRow } from '../../types'
import '../CreateEntityForm/CreateEntityForm.css'
import './ConfigTagsInput.css'

// Dynamic, free-form tag editor: the user adds/removes arbitrary key/value rows.
// Tags are optional — submitting with zero rows is valid. The parent collects
// the rows into a `tags` object (see collectTags) at submit time.
export function ConfigTagsInput({ rows, onChange }: ConfigTagsInputProps) {
  function updateRow(index: number, patch: Partial<TagRow>) {
    onChange(rows.map((row, i) => (i === index ? { ...row, ...patch } : row)))
  }

  function addRow() {
    onChange([...rows, { key: '', value: '' }])
  }

  function removeRow(index: number) {
    onChange(rows.filter((_, i) => i !== index))
  }

  return (
    <div className="create-form-table config-tags-input">
      {rows.map((row, index) => (
        <div key={index} className="config-tags-input-row">
          <input
            type="text"
            className="form-control form-control-sm config-tags-input-key"
            placeholder="Key"
            aria-label={`Tag key ${index + 1}`}
            value={row.key}
            onChange={(e) => updateRow(index, { key: e.target.value })}
          />
          <input
            type="text"
            className="form-control form-control-sm config-tags-input-value"
            placeholder="Value"
            aria-label={`Tag value ${index + 1}`}
            value={row.value}
            onChange={(e) => updateRow(index, { value: e.target.value })}
          />
          <button
            type="button"
            className="btn btn-outline-danger btn-sm"
            aria-label={`Remove tag ${index + 1}`}
            onClick={() => removeRow(index)}
          >
            Remove
          </button>
        </div>
      ))}

      <div className="config-tags-input-add-row">
        <button
          type="button"
          className="btn btn-outline-secondary btn-sm"
          onClick={addRow}
        >
          Add tag
        </button>
      </div>
    </div>
  )
}
